// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file resy/user.proto (package com.americanexpress.dining.resy.proto, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file resy/user.proto.
 */
export const file_resy_user: GenFile = /*@__PURE__*/
  fileDesc("Cg9yZXN5L3VzZXIucHJvdG8SJWNvbS5hbWVyaWNhbmV4cHJlc3MuZGluaW5nLnJlc3kucHJvdG8itAQKCFJlc3lVc2VyEhAKA2JpbxgBIAEoCUgAiAEBEhoKDWRhdGVfb2ZfYmlydGgYAiABKAlIAYgBARIUCgxkaWV0YXJ5X3RhZ3MYAyADKAkSUQoPcGF5bWVudF9tZXRob2RzGAQgAygLMjguY29tLmFtZXJpY2FuZXhwcmVzcy5kaW5pbmcucmVzeS5wcm90by5SZXN5UGF5bWVudE1ldGhvZBIXCgplbV9hZGRyZXNzGAUgASgJSAKIAQESGgoNbW9iaWxlX251bWJlchgGIAEoCUgDiAEBEiYKGW1vYmlsZV9udW1iZXJfaXNfdmVyaWZpZWQYByABKAhIBIgBARIbCg5lbV9pc192ZXJpZmllZBgIIAEoCEgFiAEBEhkKDGlzX2NvbmNpZXJnZRgJIAEoCEgGiAEBElMKEGV4Y2x1c2l2ZV9ncm91cHMYCiADKA4yOS5jb20uYW1lcmljYW5leHByZXNzLmRpbmluZy5yZXN5LnByb3RvLlJlc3lFeGNsdXNpdmVHcm91cBIZCgxkYXRlX2NyZWF0ZWQYCyABKAlIB4gBAUIGCgRfYmlvQhAKDl9kYXRlX29mX2JpcnRoQg0KC19lbV9hZGRyZXNzQhAKDl9tb2JpbGVfbnVtYmVyQhwKGl9tb2JpbGVfbnVtYmVyX2lzX3ZlcmlmaWVkQhEKD19lbV9pc192ZXJpZmllZEIPCg1faXNfY29uY2llcmdlQg8KDV9kYXRlX2NyZWF0ZWQitQIKEVJlc3lQYXltZW50TWV0aG9kEg8KAmlkGAEgASgESACIAQESFAoHZGlzcGxheRgCIAEoCUgBiAEBEhEKBHR5cGUYAyABKAlIAogBARIaCg1wcm92aWRlcl9uYW1lGAQgASgJSAOIAQESFQoIZXhwX3llYXIYBSABKAVIBIgBARIWCglleHBfbW9udGgYBiABKAVIBYgBARIXCgppc19kZWZhdWx0GAcgASgISAaIAQESGQoMaXNzdWluZ19iYW5rGAggASgJSAeIAQFCBQoDX2lkQgoKCF9kaXNwbGF5QgcKBV90eXBlQhAKDl9wcm92aWRlcl9uYW1lQgsKCV9leHBfeWVhckIMCgpfZXhwX21vbnRoQg0KC19pc19kZWZhdWx0Qg8KDV9pc3N1aW5nX2JhbmsqgwEKElJlc3lFeGNsdXNpdmVHcm91cBIkCiBSRVNZX0VYQ0xVU0lWRV9HUk9VUF9VTlNQRUNJRklFRBAAEh0KGFJFU1lfRVhDTFVTSVZFX0dST1VQX0dEQRDoBxIoCiNSRVNZX0VYQ0xVU0lWRV9HUk9VUF9QTEFUSU5VTV9OSUdIVBCrJ0IpCiVjb20uYW1lcmljYW5leHByZXNzLmRpbmluZy5yZXN5LnByb3RvUAFiBnByb3RvMw");

/**
 * @generated from message com.americanexpress.dining.resy.proto.ResyUser
 */
export type ResyUser = Message<"com.americanexpress.dining.resy.proto.ResyUser"> & {
  /**
   * @generated from field: optional string bio = 1;
   */
  bio?: string;

  /**
   * ISO-8601 date string (YYYY-MM-DD)
   *
   * @generated from field: optional string date_of_birth = 2;
   */
  dateOfBirth?: string;

  /**
   * tag names from Resy
   *
   * @generated from field: repeated string dietary_tags = 3;
   */
  dietaryTags: string[];

  /**
   * @generated from field: repeated com.americanexpress.dining.resy.proto.ResyPaymentMethod payment_methods = 4;
   */
  paymentMethods: ResyPaymentMethod[];

  /**
   * @generated from field: optional string em_address = 5;
   */
  emAddress?: string;

  /**
   * @generated from field: optional string mobile_number = 6;
   */
  mobileNumber?: string;

  /**
   * @generated from field: optional bool mobile_number_is_verified = 7;
   */
  mobileNumberIsVerified?: boolean;

  /**
   * @generated from field: optional bool em_is_verified = 8;
   */
  emIsVerified?: boolean;

  /**
   * @generated from field: optional bool is_concierge = 9;
   */
  isConcierge?: boolean;

  /**
   * @generated from field: repeated com.americanexpress.dining.resy.proto.ResyExclusiveGroup exclusive_groups = 10;
   */
  exclusiveGroups: ResyExclusiveGroup[];

  /**
   * @generated from field: optional string date_created = 11;
   */
  dateCreated?: string;
};

/**
 * Describes the message com.americanexpress.dining.resy.proto.ResyUser.
 * Use `create(ResyUserSchema)` to create a new message.
 */
export const ResyUserSchema: GenMessage<ResyUser> = /*@__PURE__*/
  messageDesc(file_resy_user, 0);

/**
 * @generated from message com.americanexpress.dining.resy.proto.ResyPaymentMethod
 */
export type ResyPaymentMethod = Message<"com.americanexpress.dining.resy.proto.ResyPaymentMethod"> & {
  /**
   * @generated from field: optional uint64 id = 1;
   */
  id?: bigint;

  /**
   * @generated from field: optional string display = 2;
   */
  display?: string;

  /**
   * @generated from field: optional string type = 3;
   */
  type?: string;

  /**
   * @generated from field: optional string provider_name = 4;
   */
  providerName?: string;

  /**
   * @generated from field: optional int32 exp_year = 5;
   */
  expYear?: number;

  /**
   * @generated from field: optional int32 exp_month = 6;
   */
  expMonth?: number;

  /**
   * @generated from field: optional bool is_default = 7;
   */
  isDefault?: boolean;

  /**
   * @generated from field: optional string issuing_bank = 8;
   */
  issuingBank?: string;
};

/**
 * Describes the message com.americanexpress.dining.resy.proto.ResyPaymentMethod.
 * Use `create(ResyPaymentMethodSchema)` to create a new message.
 */
export const ResyPaymentMethodSchema: GenMessage<ResyPaymentMethod> = /*@__PURE__*/
  messageDesc(file_resy_user, 1);

/**
 * Exclusive group membership IDs sourced from the Resy /3/gdus/user/:id endpoint.
 * Numeric values match the IDs used in the Resy platform (select/api/core.py).
 *
 * @generated from enum com.americanexpress.dining.resy.proto.ResyExclusiveGroup
 */
export enum ResyExclusiveGroup {
  /**
   * EXCLUSIVE_ID_COMMON_ACCESS
   *
   * @generated from enum value: RESY_EXCLUSIVE_GROUP_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * EXCLUSIVE_ID_GLOBAL_DINING_ACCESS
   *
   * @generated from enum value: RESY_EXCLUSIVE_GROUP_GDA = 1000;
   */
  GDA = 1000,

  /**
   * EXCLUSIVE_ID_PLATINUM_NIGHT
   *
   * @generated from enum value: RESY_EXCLUSIVE_GROUP_PLATINUM_NIGHT = 5035;
   */
  PLATINUM_NIGHT = 5035,
}

/**
 * Describes the enum com.americanexpress.dining.resy.proto.ResyExclusiveGroup.
 */
export const ResyExclusiveGroupSchema: GenEnum<ResyExclusiveGroup> = /*@__PURE__*/
  enumDesc(file_resy_user, 0);

